import { render, staticRenderFns } from "./FiaIntelligenceCard.vue?vue&type=template&id=6165b963&scoped=true&"
import script from "./FiaIntelligenceCard.vue?vue&type=script&lang=js&"
export * from "./FiaIntelligenceCard.vue?vue&type=script&lang=js&"
import style0 from "./FiaIntelligenceCard.vue?vue&type=style&index=0&id=6165b963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165b963",
  null
  
)

export default component.exports